/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { useQuery, gql } from '@apollo/client';
import { handleApolloError } from '@exo/frontend-common-apollo';
import { useState } from 'react';

export const FILTER_PRODUCTS = gql`
  query Products ($filter: ProductFilter!, $sort: ProductOrderBy, $first: Int, $cursor: String) {
    products(filter: $filter, orderBy: $sort, first: $first, after: $cursor) {
      edges {
        node {
          parentCategory {
            id
            name
          }
          id
          children {
            id
            thumbnail
            slug
          }
          name
          partnumber
          description
          thumbnail
          slug
          longDescription
          fullImage

          price {
            list {
              value
              currency
            }
            offer {
              value
              currency
            }
          }
          allAttributes {
            id
            value {
              id
              value
            }
          }
          attributes {
            name
            categoryName
            value {
              value
              sequence
              id
            }
          }
          type
          sortedData {
            id
            name
            fullImage
            price {
              list {
                value
                currency
              }
              offer {
                value
                currency
              }
            }
          }
          selection {
            id
            criteria {
              name
              id
              criteriaId
              value {
                value
                sequence
                id
              }
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        totalResultsCount
      }
    }
  }
`;

export const useCategoryFilterForProducts = (filter, sort, first) => {
  const [isLoading,setisLoading]=useState(false)
  const { called, loading, data, error, fetchMore } = useQuery(FILTER_PRODUCTS, {
    variables: {
      filter,
      sort,
      first
    }
  });

  const onLoadMore = () => {
    setisLoading(true)
    fetchMore({
      variables: {
        cursor: data?.products?.pageInfo?.endCursor
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        const newEdges = fetchMoreResult.products.edges;
        const { pageInfo } = fetchMoreResult.products;
         setisLoading(false)
        return newEdges.length
          ? {
              products: {
                // eslint-disable-next-line no-underscore-dangle
                __typename: previousResult.products.__typename,
                edges: [...previousResult.products.edges, ...newEdges],
                pageInfo
              }
            }
          : previousResult;
      }
    });
  };

  handleApolloError(__filename, error);

  return { called, loading, data: data, error, onLoadMore,isLoading };
};

export const useFilterForCatProducts = (filter, sort) => {
  const { called, loading, data, error } = useQuery(FILTER_PRODUCTS, {
    variables: {
      filter,
      sort
    }
  });
  return { called, loading, data: data, error };
}